<template>
  <div class="subasta-view">
    <!-- Imagen Destacada -->
    <section class="position-relative">
      <img
        class="w-100 d-none d-md-block"
        src="https://amercado.azureedge.net/cms/resources/images/subastas/3289/5066724ca4b0d968447697ec6b4de649-desktop.jpg"
        alt="Imagen destacada de la subasta"
      />
      <img
        class="w-100 d-md-none"
        src="https://amercado.azureedge.net/cms/resources/images/subastas/3289/5066724ca4b0d968447697ec6b4de649-mobile.jpg"
        alt="Imagen destacada de la subasta"
      />
    </section>

    <!-- Título y Datos -->
    <section class="container my-4">
      <div class="row">
        <div class="col-md-8">
          <h1 class="fs-4 fw-bold">
            Importante subasta de electrodomésticos con 30 días de garantía
          </h1>
          <h3 class="text-muted fs-5">
            Heladeras, microondas, lavarropas, secarropas, purificador, cocinas y más
          </h3>
          <div class="d-flex flex-wrap mt-3">
            <span class="badge bg-success me-2">EN CURSO</span>
            <span class="text-muted me-3">
              <i class="far fa-calendar-alt"></i> Martes 10/12/2024
            </span>
            <span class="text-muted me-3">
              <i class="far fa-clock"></i> 14:00 h
            </span>
            <span class="text-muted">
              <i class="far fa-folder-open"></i> ID 1031
            </span>
          </div>
        </div>
        <div class="col-md-4 text-md-end mt-4 mt-md-0">
          <button class="btn btn-primary btn-lg">
            Ingresar a la sala
          </button>
        </div>
      </div>
    </section>

    <!-- Tabs -->
    <section class="container my-4">
      <ul class="nav nav-tabs" id="subastaTabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="ubicacion-tab"
            data-bs-toggle="tab"
            data-bs-target="#ubicacion"
            type="button"
            role="tab"
            aria-controls="ubicacion"
            aria-selected="true"
          >
            Ubicación
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="condiciones-tab"
            data-bs-toggle="tab"
            data-bs-target="#condiciones"
            type="button"
            role="tab"
            aria-controls="condiciones"
            aria-selected="false"
          >
            Términos y Condiciones
          </button>
        </li>
      </ul>
      <div class="tab-content" id="subastaTabsContent">
        <!-- Ubicación -->
        <div
          class="tab-pane fade show active p-4 bg-white border"
          id="ubicacion"
          role="tabpanel"
          aria-labelledby="ubicacion-tab"
        >
          <p>
            <strong>Ubicación:</strong> Av. Dr. Ricardo Balbín 4020, B1722 Merlo, Buenos Aires
          </p>
          <p>
            <strong>Fecha y horario de exhibición:</strong> Viernes 6/12 y Lunes 9/12 de 10:00 a 15:00 hs.
          </p>
          <img
            class="img-fluid rounded"
            alt="Ubicación"
            src="https://maps.googleapis.com/maps/api/staticmap?scale=2&size=540x190&zoom=13&maptype=roadmap&markers=icon:https://www.adrianmercado.com.ar/images/pin_azul_solido_x2.png|-34.6819753,-58.7602536&key=AIzaSyASEi_WIy9_MAH4Pf320G-Wqj1JVsLQihk"
          />
        </div>

        <!-- Términos y Condiciones -->
        <div
          class="tab-pane fade p-4 bg-white border"
          id="condiciones"
          role="tabpanel"
          aria-labelledby="condiciones-tab"
        >
          <p>
            Aquí puedes agregar los términos y condiciones de la subasta. Si deseas contenido dinámico,
            conecta este contenido con tu API o base de datos.
          </p>
        </div>
      </div>
    </section>

    <!-- Formulario de Contacto -->
    <section class="container my-4">
      <div class="bg-light p-4 rounded">
        <h2 class="mb-4">Consultar por esta subasta</h2>
        <form>
          <div class="mb-3">
            <label for="nombre" class="form-label">Nombre completo</label>
            <input type="text" class="form-control" id="nombre" required />
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="email" class="form-control" id="email" required />
          </div>
          <div class="mb-3">
            <label for="mensaje" class="form-label">Consulta</label>
            <textarea class="form-control" id="mensaje" rows="3"></textarea>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" id="novedades" />
            <label class="form-check-label" for="novedades">
              Deseo recibir novedades acerca de todas las subastas.
            </label>
          </div>
          <button type="submit" class="btn btn-primary">Enviar</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SubastaView",
};
</script>

<style scoped>
/* Personalización de estilos específicos */
.subasta-view {
  background-color: #f9f9f9;
}
</style>
